module.exports = __webpack_public_path__ + "static/media/2-1.2c1315d6.png";